import axios from "axios";
import { handleError } from "./errorHandler.ts";

const api = axios.create({
  baseURL: "https://www.api.etpm.chiksoft.com/api/", 
  timeout: 240000,
});

// Interceptor to add Authorization header automatically
api.interceptors.request.use((config) => {
const token = localStorage.getItem("token");
if (token) {
    config.headers.Authorization = `Bearer ${token}`;
} 
return config;
});

// Interceptor for handling errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    handleError(error);
    return Promise.reject(error);
  }
);

export default api;
